<template>
    <form action="#" class="form" v-on:submit.prevent ref="form">
        <div class="fields-group">
            <field-wrapper @focus="error" :isError="error" type="password" v-model="password" label="Придумайте пароль" :options="{required: true, minLength: 8}"></field-wrapper>
            <field-wrapper @focus="error" :isError="error" type="password" v-model="repeatPassword" label="Повторите пароль" :hint="msg" :options="{required: true, minLength: 8}"></field-wrapper>
        </div>
        <button type="submit" class="btn" @click="btnClick">Создать пароль</button>
    </form>
</template>

<script>
    import FieldWrapper from "../common/fields/FieldWrapper";
    import axios from 'axios'
    import {NOTIFICATION_WARNING} from "../../constants/common";

    export default {
        name: 'candidate-login-form',
        components: {FieldWrapper},
        data() {
            return {
                password: '',
                repeatPassword: '',
                msg: 'Используйте не менее 8 символов',
                error: false,
            }
        },
        computed: {},
        methods: {
            btnClick() {
                if (!this.$refs.form.checkValidity()) {
                    this.$refs.form.reportValidity();
                } else {
                    if (this.password !== this.repeatPassword) {
                        this.$store.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: 'Пароли не совпадают.', time: 5000});
                        return false;
                    }
                    window.location.href = "/questionnaire";
                    /*this.loading = true;
                    axios.post('/api/login' , {email: this.email, password: this.password, remember: this.remember})
                        .then((response) => {
                            if (response.data.success) {
                                window.location.href = "/questionnaire";
                            } else {
                                let text = response.data.error;
                                this.$store.dispatch('pushNotification', {type: NOTIFICATION_WARNING, text: text, time: 5000});
                                this.error = true
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            this.$store.dispatch('errorHandler', error);
                            this.loading = false;
                        });*/
                }
               /* if (this.password !== this.repeatPassword) {
                    this.msg = 'Пароли не совпадают';
                    this.error = true;
                    return false
                } else if (this.password.length < 8) {
                    this.msg = 'Используйте не менее 8 символов';
                    this.error = true;
                    return false
                } else {
                    this.$store.dispatch('user/authUser');
                    this.$router.push({path: '/questionnaire'})
                }*/
            },
        },
    }
</script>


<style scoped>


</style>
